<template>
  <!-- <layout> -->
    <router-view />
  <!-- </layout> -->
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import utils from './utils/index'

export default {
  name: 'app',
  data () {
    return {
      entryUrl: ''
    }
  },
  computed: {
    ...mapState([
      'loginUser',
      'isMobile'
    ])
  },
  created () {
    this.entryUrl = window.location.href
    this.setMoblie(this.checkMobile())
    this.getNowTime()
    this.getPhoneList()
    // this.getSigninInfo()
  },
  mounted () {
    window.onresize = function () {
      this.setMoblie(this.checkMobile())
    }.bind(this)
    // 如果是在 苹果浏览器内 给body 添加 class 做兼容处理
    if (utils.isIOS()) {
      document.body.classList.add('ios')
    }
  },
  methods: {
    ...mapActions([
      'getNowTime',
      'getSigninInfo',
      // 'getLayoutNav',
      'getPhoneList'
    ]),
    ...mapMutations({
      setMoblie: 'CHECK_MOBILE'
    }),
    checkMobile () {
      const ua = navigator.userAgent.toLowerCase()
      return (/iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua)) || document.body.clientWidth <= 768
    }
  }
}
</script>

<style lang="scss">
@import '~vue2-scrollbar/dist/style/vue2-scrollbar.css';
@import '~@geekbang/geek.ui/src/assets/css/reset';
@import './assets/css/custom.loading';
@import './assets/css/custom.button';
@import './assets/css/custom.dialog';
@import './assets/css/custom.popup';
@import './assets/css/custom.form';
@import './assets/css/custom.message';
@import './assets/css/custom.paging';
@import './assets/css/custom.select';
@import './assets/css/base';

html {
  background: #FFF;
  min-height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  min-height: 100vh;
  background: #FFF;
}
body.fixed {
  overflow: hidden;
  position: fixed;
  width: 100vw; height: 100vh;
}
i {
  font-style: normal;
}
a {
  word-wrap: break-word;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: $blue;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-in-top-enter-active,
.slide-in-top-leave-active,
.slide-in-right-enter-active,
.slide-in-right-leave-active {
  transition: all 0.3s ease;
}
.slide-in-top-enter,
.slide-in-top-leave-to {
  transform: translateY(5px);
  opacity: 0;
}
</style>
